import { SavedCardData } from "~/features/plus/ui/modal/PlusSubscriptionModal";

export interface ModalState {
  marketingOptIn: boolean;
  promotionName: string | undefined;
  shippingId: number;
  savedCardId: number | undefined;
  cardSaveError: boolean;
  cardVerificationError: boolean;
  subscribeError: boolean;
  subscribeCustomErrorMessage: string;
  submitting: boolean;
  welcomeMessageIsVisible: boolean;
  onCloseUrlUpdate: string | null;
  savedCardData: readonly SavedCardData[];
}

export const initialState: ModalState = {
  marketingOptIn: true,
  promotionName: undefined,
  shippingId: 0,
  savedCardId: undefined,
  cardSaveError: false,
  cardVerificationError: false,
  subscribeError: false,
  subscribeCustomErrorMessage: "",
  submitting: false,
  welcomeMessageIsVisible: false,
  onCloseUrlUpdate: null,
  savedCardData: [],
};
